import { IChatState } from "./ChatState";
import { REACT_APP_HOST_ROUTE } from "src/app/chat/~api/apiRoutes";
import { createSignalRConnection } from "src/~signalR/SignalRHub"

export const initChatState: IChatState = {
    messages: [],
    isMessageEditing: false,
    isGettingPrevChatMessages: false,
    hubConnection: createSignalRConnection(REACT_APP_HOST_ROUTE),
    sendingFilesCount: 0,
    footerCompanyName: "",
    sendingMessage: null,
    footerCompanyUrl: "",
    customerId: "",
    hideClientStartMessage: false,
    loadPrevChat: false
}
